var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcHotBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20630_5580",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20630_5580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.93462 8.95805H4.13076C3.96399 8.95805 3.84228 8.88588 3.76562 8.74155C3.68897 8.59721 3.6929 8.45437 3.77741 8.31303L7.19099 2.90153C7.25007 2.7916 7.3357 2.72131 7.44787 2.69064C7.56006 2.65998 7.67224 2.66335 7.78441 2.70075C7.89658 2.73814 7.98558 2.80657 8.05139 2.90602C8.1172 3.00549 8.14225 3.11617 8.12655 3.23807L7.71709 6.74141H9.70378C9.88252 6.74141 10.0097 6.81994 10.0852 6.97699C10.1607 7.13404 10.1454 7.28324 10.0392 7.42458L6.29469 12.209C6.21991 12.2995 6.12886 12.3595 6.02153 12.389C5.91422 12.4186 5.80746 12.4068 5.70127 12.3537C5.59507 12.3006 5.51487 12.2243 5.46066 12.1249C5.40644 12.0254 5.39204 11.9196 5.41746 11.8074L5.93462 8.95805Z",
    fill: "#CC213C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHotBadge);
export default __webpack_public_path__ + "static/media/ic-hot-badge.ff7fda59b83b27bd251a9cfe12b43484.svg";
export { ForwardRef as ReactComponent };